import React from "react";
import "./cta.scss";
import CustomButton from "../../shared/custom-button/custom-button";
import { NavLink } from "react-router-dom";

const ServiceCTA = ({
  imageSrc,
  text = "Transform your organisation with structured systems, stronger governance, and improved clarity. Our advisors work closely with leadership to diagnose gaps, redesign processes, and guide implementation. Start your transformation journey with Amicus and build a more resilient, future-ready business.",
  buttonText = "Request a Consultation",
  onButtonClick,
}) => {
  return (
    <section className="service-cta-wrapper">
      <div className="service-cta-container">
        {imageSrc && (
          <div className="cta-image-section">
            <img src={imageSrc} alt="Service CTA" />
            <div className="image-overlay" />
          </div>
        )}
        <div
          className="cta-content-section"
          style={!imageSrc ? { paddingLeft: "4rem" } : {}}
        >
          <p>{text}</p>
        </div>
        <div className="cta-action-section">
          <CustomButton to={"/contact"} as={NavLink} onClick={onButtonClick}>
            {buttonText}
          </CustomButton>
        </div>
      </div>
    </section>
  );
};

export default ServiceCTA;
